import { render, staticRenderFns } from "./TableCounter.vue?vue&type=template&id=4130f500"
import script from "./TableCounter.vue?vue&type=script&lang=js"
export * from "./TableCounter.vue?vue&type=script&lang=js"
import style0 from "./TableCounter.vue?vue&type=style&index=0&id=4130f500&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports